import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layouts/layout.component';

// Auth
import { AuthGuard } from './core/guards/auth.guard';
import { NeedLoggin } from './core/services/isLoggedIn.service';

const routes: Routes = [
  // { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)/*, canActivate: [AuthGuard]*/ },
  { path: 'auth', loadChildren: () => import('./account/account.module').then(m => m.AccountModule)  },
  { path: 'pages', loadChildren: () => import('./extraspages/extraspages.module').then(m => m.ExtraspagesModule), canActivate: [AuthGuard] },
  { path: 'landing', loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule)},
  {
    path: '',
    component: LayoutComponent,
    canActivate: [NeedLoggin],//NgxPermissionsGuard
    data: {
      // permissions: {
      //   only: ['ROLE_ADMIN'],
      //   redirectTo: '/home',
      // },
    },
    loadChildren: () => import('./pages/carrier/carrier.module').then(m => m.CarrierModule),
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '', // Ruta para manejar URLs no encontradas
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
